export const SHOP_SPECIFIC_AFTERPAY_SETTINGS = {
  default: {
    minimumPriceThreshold: 1000,
    maximumPriceThreshold: 200000,
    modalContent: 'allbirds_us',
  },
  // more shops to be added if experiment wins
};
